import * as D from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import * as React from 'react';

// shadcn-style dialog on Radix: focus trapped, Escape closes, title announced.
export function Dialog({ open, onOpenChange, title, description, children, footer, wide }: {
  open: boolean; onOpenChange: (o: boolean) => void; title: string; description?: React.ReactNode; children: React.ReactNode; footer?: React.ReactNode; wide?: boolean;
}) {
  return (
    <D.Root open={open} onOpenChange={onOpenChange}>
      <D.Portal>
        <D.Overlay className="fixed inset-0 z-40 bg-night/40" />
        <D.Content className={`fixed left-1/2 top-1/2 z-50 max-h-[90vh] w-[calc(100vw-2rem)] -translate-x-1/2 -translate-y-1/2 overflow-y-auto rounded-xl bg-surface p-6 shadow-xl ${wide ? 'max-w-3xl' : 'max-w-lg'}`}>
          <div className="flex items-start justify-between gap-4">
            <D.Title className="font-display text-lg font-bold text-ink">{title}</D.Title>
            <D.Close className="rounded-md p-1 text-ink-3 hover:bg-canvas" aria-label="Close"><X className="size-4" /></D.Close>
          </div>
          {description ? <D.Description className="mt-1 text-sm text-ink-2">{description}</D.Description> : <D.Description className="sr-only">{title}</D.Description>}
          <div className="mt-4">{children}</div>
          {footer && <div className="mt-6 flex flex-wrap justify-end gap-2">{footer}</div>}
        </D.Content>
      </D.Portal>
    </D.Root>
  );
}
